import { ERROR_MAX_QUERIES } from './../../error/errorMessage';
import { BefreiungErgebnis } from './../shared/entities/befreiungErgebnis';
import { AbstractBefreiungService } from './../shared/services/abstract-befreiung.service';
import { IAppState } from './../../appState/app.state';
import { Router } from '@angular/router';
import { Component, OnInit, Inject, AfterViewInit, ViewChildren } from '@angular/core';

import { kvNummerIsValid } from './../shared/kvNummerIsValid';
import { Store } from '@ngrx/store';
import { Einwilligung } from '../shared/einwilligung';
import { ErrorAction, BefreiungGefundenAction } from '../../appState/app.actions';
import { AppState } from '../../appState/appStateStore.module';

@Component({
  selector: 'app-suche',
  templateUrl: './suche.component.html',
  styleUrls: ['./suche.component.css']
})
export class SucheComponent implements OnInit, AfterViewInit {
  @ViewChildren('kv') vc;
  kvNummer: string;
  message: string;
  isBeratung = false;
  isBetreuung = false;

  constructor( private router: Router, private store: Store<AppState>, private befreiungService: AbstractBefreiungService) { }

  ngOnInit() { }

  ngAfterViewInit(): void {
    this.vc.first.nativeElement.focus();
  }

  onSubmit() {
    this.kvNummer = this.kvNummer.toUpperCase();
    if (this.isBeratung === this.isBetreuung) {
      return;
    }

    const einwilligung = this.isBeratung ? Einwilligung.persoenlicher_Kontakt : Einwilligung.Einverstaendniserklaerung;

    return this.befreiungService.getBefreiung(this.kvNummer, einwilligung)
      .then(befreiung => this.befreiungAnzeigen(befreiung))
      .catch(err => {
        if (err === ERROR_MAX_QUERIES.title) {
          this.store.dispatch( new ErrorAction(ERROR_MAX_QUERIES));
          this.router.navigate(['/error']);
        }

        this.message = this.kvNummer + '<br/>' + err;
        this.kvNummer = null;
        this.isBeratung = false;
        this.isBetreuung = false;
      });
  }

  befreiungAnzeigen(befreiung: BefreiungErgebnis) {
    this.store.dispatch( new BefreiungGefundenAction(befreiung) );
    this.router.navigate(['/befreiungErgebnis']);
  }

  clearMessage() {
    this.message = null;
  }

  formIsValid():boolean {
    if (this.isBeratung === this.isBetreuung || this.message) {
      return false;
    }
    const regex = /^[A-Za-z]\d{9}$|^\d{9}$/g
    return regex.test(this.kvNummer);
  }


  // Nur einer von beiden kann aktiviert sein.
  onErklaerungChange($event) {
    if (!$event.target.checked) {
      return;
    }
    if ($event.target.name === 'beratung') {
      this.isBetreuung = false;
    } else {
      this.isBeratung = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/befreiung/suche/suche.component.ts